<template>
  <div :class="[ 'c-multi-select-raw', { '-validation': !!validation, '-label-left': labelLeft } ]">
    <c-select-raw
      class="select"
      :value="computedValue"
      :validation="validation"
      :options="availableOptions"
      :track-by="trackBy"
      :display-by="displayBy"
      :label-left="labelLeft"
      v-bind="getAttrs($attrs)"
      @input="onInput"
      @add-option="$emit('add-option')"
    />

    <c-multi-select-item-list
      v-if="(computedValue || []).length"
      class="selected"
      :items="computedValue"
      :display-by="displayBy"
      v-bind="$attrs"
      @remove="onRemove"
    />
  </div>
</template>

<script>
import CMultiSelectItemList from '@convenia/components/CMultiSelectItemList/index.vue'
// eslint-disable-next-line import/no-unresolved
import CSelectRaw from '@convenia/components/CSelect/fragments/CSelectRaw?ignore-next=1'
import CommonMixin from './CommonMixin'

export default {
  components: { CSelectRaw, CMultiSelectItemList },

  mixins: [ CommonMixin ],

  methods: {
    getAttrs (attrs) {
      return {
        ...attrs,
        disabled: (attrs.disabled || !this.availableOptions.length) && !this.habilityEmptyOption,
        habilityEmptyOption: this.habilityEmptyOption,
        keepAllOptionsAvailable: this.keepAllOptionsAvailable
      }
    }
  }
}
</script>

<style lang="scss">
.c-multi-select {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.c-multi-select-raw {
  min-width: 0;

  & > .select {
    max-width: 100%;
  }
}
</style>
